import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ScreenUtils } from 'src/app/utils/screen.utils';

@Pipe({
  name: 'calculationText'
})
@Injectable({
  providedIn: 'root'
})
export class CalculationTextPipe implements PipeTransform {
  isMobile: boolean = ScreenUtils.isMobile();

  constructor(private translateService: TranslateService) {}

  transform(key: string, coverage: string, destination: string): string {

    if (coverage === 'ROUNDTRIP') {
      key = key + '.roundtrip';
    } else {
      key = key + '.one-way';
      key = destination === 'AIRPORT' ? key + '.airport' : key + '.place';
    }

    if (this.isMobile) {
      key = key + '.mobile';
    }

    return this.translate(key);
  }

  private translate(key: string) {
    return this.translateService.instant(key);
  }
}
